import { AdminPageHeader } from '@/components/patterns/admin-page'
import { DomainForm } from '@/components/forms/DomainForm'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { Globe } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/website/domains/create')({
  component: CreateDomainPage,
  loader: ({ context }) => {
    if (!context.ability.can('create', 'domains')) throw notFound()
    return { isReadOnly: false }
  },
})

export function CreateDomainPage() {
  return (
    <div className="max-w-4xl space-y-4">
      <AdminPageHeader icon={Globe} title="Create New Domain" />
      <DomainForm />
    </div>
  )
}
